import React from 'react';
import Header from '../../../components/layout/headers/Header';
import DynamicNavigation from "../../../components/layout/navigation/DynamicNavigation";
import ClaimsList from "../components/ClaimsList";
import {Divider} from 'primereact/divider';
import AppCard from '../../../components/ui/AppCard';
import {Button} from 'primereact/button';
import paymentImage from "../../../assets/images/patterns/loans-bg.png"
import {useHistory} from 'react-router-dom';

const ClaimsDashboard = () => {
    const history = useHistory();

    return (
        <>
            <Header />
            <DynamicNavigation />
            <div className="min-h-screen bg-base-200 pt-28 pb-8">
                <div className="container mx-auto px-4 max-w-7xl">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <div className="flex flex-col">
                            <AppCard headerImg={paymentImage}>
                                <div className="mb-4">
                                    <span className="badge badge-info bg-blue-100 text-blue-700 border-none badge-sm uppercase font-bold mb-3 px-3 py-3 rounded-full tracking-wider text-xs">Claims</span>
                                    <h2 className="text-2xl font-extrabold text-base-content mb-2 tracking-tight">File a new claim</h2>
                                    <p className="text-sm text-base-content/70">Submit a new claim easily and efficiently.</p>
                                </div>
                                <Divider type="solid" className="opacity-30 my-4" />
                                
                                <div className='space-y-4'>
                                    <div>
                                        <Button
                                            onClick={() => { history.push("/claims/create") }}
                                            className="justify-content-center text-center font-bold"
                                            size="large"
                                            label="File a Claim"
                                            icon="pi pi-plus"
                                            severity="info"
                                            rounded
                                            raised
                                        />
                                    </div>
                                    <div>
                                        <Divider type="solid" className="opacity-30 my-4" />
                                        <p className="text-sm text-base-content/70">Submit your claim details and upload supporting documents directly from here.</p>
                                    </div>
                                </div>
                            </AppCard>
                        </div>
                        <div className="flex flex-col">
                            <ClaimsList />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ClaimsDashboard;
